import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { unstable_useId as useId } from '@mui/material/utils'
import { Close } from 'shared/assets'
import { downloadSvg } from 'shared/utils'
import QRCodeWrapper from '../QRCodeWrapper'
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from './QRCodeDialog.style'

export interface QRCodeDialogProps {
  code: string | null
  title: string
  downloadLabel: string
  onClose: () => void
}

const QRCodeDialog = ({
  code,
  title,
  downloadLabel,
  onClose,
}: QRCodeDialogProps) => {
  const { t } = useTranslation()
  const titleId = useId()
  const qrCodeElementId = useId()
  const [lastCode, setLastCode] = useState(code)

  if (code !== null && code !== lastCode) setLastCode(code)

  const displayedCode = code ?? lastCode

  return (
    <Dialog open={code !== null} onClose={onClose} aria-labelledby={titleId}>
      <IconButton onClick={onClose} aria-label={t('close')}>
        <Close />
      </IconButton>

      <DialogContent>
        <DialogTitle id={titleId} textAlign="center">
          {title}
        </DialogTitle>
        {displayedCode && qrCodeElementId && (
          <>
            <QRCodeWrapper value={displayedCode} id={qrCodeElementId} />
            <Button
              variant="contained"
              onClick={() => downloadSvg({ elementId: qrCodeElementId })}
            >
              {downloadLabel}
            </Button>
          </>
        )}
      </DialogContent>
    </Dialog>
  )
}

export default QRCodeDialog
